"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureContext = exports.AcornFeatureContainer = exports.AcornFeatureContainerContext = exports.useFeatures = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useFeatures = function () {
    // Track features as a simple mutable list. This was originally done using state
    // however there was no guarantees that multiple sequential calls to addFeature
    // would result in the order of features being preserved and there were
    // many more additional renders triggered.
    var featureListRef = react_1.useRef({});
    // As the features collection is a simple mutable object we need some way
    // to cause components to re-render. This approach is simple: we simply
    // digest the features into a list and store that in state.
    //
    // This list is returned by the hook and consumed by users of the hook
    //
    // Note that many other approaches were attempted, to this solution of useRef and
    // useState(). This final solution has reduced rendering counts
    // down to 1 render per call to addFeature
    var _a = react_1.useState([]), featureList = _a[0], setFeatureList = _a[1];
    /**
     * Adds a feature to the list of features encapsulated by the hook
     */
    var addFeatures = react_1.useCallback(function (features) {
        var dirty = false;
        features.forEach(function (feature) {
            if (featureListRef.current[feature.path]) {
                return;
            }
            featureListRef.current[feature.path] = feature;
            dirty = true;
        });
        if (dirty) {
            setFeatureList(Object.values(featureListRef.current));
        }
    }, []);
    // While we store features locally indexed against their rootPath just in case
    // there ever is a subsequent recall to addFeature, our components need just
    // a simple ordered list of features.
    // To save other components having to reduce the features' endpoints to a list
    // we do this here with useMemo to avoid unnecessary recomputation.
    var menu = react_1.useMemo(function () {
        return featureList.reduce(function (menu, feature) {
            if (feature.menuPaths) {
                feature.menuPaths.forEach(function (menuPath) {
                    var menuParts = menuPath.split('/');
                    var activeMenu = menu;
                    for (var m = 0; m < menuParts.length; m++) {
                        var part = menuParts[m];
                        if (!(part in activeMenu.children)) {
                            activeMenu.children[part] = {
                                name: part,
                                path: '',
                                children: {},
                            };
                        }
                        if (m === menuParts.length - 1) {
                            activeMenu.children[part].path = feature.path;
                            activeMenu.children[part].icon = feature.icon;
                            activeMenu.children[part].requiredPermissions = feature.requiredPermissions;
                        }
                        activeMenu = activeMenu.children[part];
                    }
                });
            }
            return menu;
        }, { children: {} });
    }, [featureList]);
    return {
        featureList: featureList,
        menu: Object.values(menu.children),
        addFeatures: addFeatures,
    };
};
exports.useFeatures = useFeatures;
/**
 * Our context object for features
 */
exports.AcornFeatureContainerContext = react_1.default.createContext({
    features: [],
    menu: [],
    addFeatures: function (features) { },
});
/**
 * A container for features.
 *
 * Allows registration of features by components which can provide navigation
 * and settings to higher application components. Note that the container component
 * must surround everything that requires access to registered features.
 *
 * Note that it is possible to nest feature containers. Inner feature containers are
 * self contained and the pattern allows for features to encapsulate their subfeatures
 * and provide secondary navigation, settings etc. in a composable, and reusable way.
 *
 * @param props
 * @returns
 */
var AcornFeatureContainer = function (props) {
    var _a = exports.useFeatures(), featureList = _a.featureList, menu = _a.menu, addFeatures = _a.addFeatures;
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(exports.AcornFeatureContainerContext.Provider, { value: {
                features: featureList,
                menu: menu,
                addFeatures: addFeatures,
            } }, props.children)));
};
exports.AcornFeatureContainer = AcornFeatureContainer;
var useFeatureContext = function () {
    return react_1.useContext(exports.AcornFeatureContainerContext);
};
exports.useFeatureContext = useFeatureContext;
//# sourceMappingURL=AcornFeatureContainer.js.map